/**
 * Created by Languagenut on 25/01/2019.
 */



import React  from 'react';
import './payment.css';
import { ProgressBar} from "react-bootstrap";
import LicenceService from '../../services/licence-service.js';
import LicenceStore   from '../../store/licence-store.js';
import Constants from '../../constants.js';
import $ from 'jquery';

const braintree = window.braintree;



export default class Payment extends React.Component {

    constructor(props) {
        super();
        this.props = props;
        this.state = {
            loading:true,
        }
    }

    setupBrainTree(){
        var self = this;

        console.log(LicenceStore.braintreeCode);
        braintree.client.create({
            authorization: LicenceStore.braintreeCode
        }, function (err, clientInstance) {
            if (err) {
                console.error(err);
                return;
            }

            braintree.hostedFields.create({
                client: clientInstance,
                styles: {
                    'input': {
                        'font-size': '14px',
                        'font-family': 'helvetica, tahoma, calibri, sans-serif',
                        'color': '#3a3a3a'
                    },
                    ':focus': {
                        'color': 'black'
                    }
                },
                fields: {
                    number: {
                        selector: '#card-number',
                        placeholder: '4111 1111 1111 1111'
                    },
                    cvv: {
                        selector: '#cvv',
                        placeholder: '123'
                    },
                    expirationDate: {
                        selector: '#expiration-date',
                        placeholder: 'MM/YY'
                    },
                }
            }, function (err, hostedFieldsInstance) {

                self.setState({loading:false});
                if (err) {
                    console.error(err);
                    return;
                }

                hostedFieldsInstance.on('validityChange', function (event) {
                    var field = event.fields[event.emittedBy];

                    if (field.isValid) {
                        if (event.emittedBy === 'expirationMonth' || event.emittedBy === 'expirationYear') {
                            if (!event.fields.expirationMonth.isValid || !event.fields.expirationYear.isValid) {
                                return;
                            }
                        } else if (event.emittedBy === 'number') {
                            $('#card-number').next('span').text('');
                        }

                        // Remove any previously applied error or warning classes
                        $(field.container).parents('.form-group').removeClass('has-warning');
                        $(field.container).parents('.form-group').removeClass('has-success');
                        // Apply styling for a valid field
                        $(field.container).parents('.form-group').addClass('has-success');
                    } else if (field.isPotentiallyValid) {
                        // Remove styling  from potentially valid fields
                        $(field.container).parents('.form-group').removeClass('has-warning');
                        $(field.container).parents('.form-group').removeClass('has-success');
                        if (event.emittedBy === 'number') {
                            $('#card-number').next('span').text('');
                        }
                    } else {
                        // Add styling to invalid fields
                        $(field.container).parents('.form-group').addClass('has-warning');
                        // Add helper text for an invalid card number
                        if (event.emittedBy === 'number') {
                            $('#card-number').next('span').text('Looks like this card number has an error.');
                        }
                    }
                });

                hostedFieldsInstance.on('cardTypeChange', function (event) {
                    // Handle a field's change, such as a change in validity or credit card type
                    if (event.cards.length === 1) {
                        $('#card-type').text(event.cards[0].niceType);
                    } else {
                        $('#card-type').text('Card');
                    }
                });

                $('.payment-body').submit(function (event) {
                    event.preventDefault();
                    hostedFieldsInstance.tokenize(function (err, payload) {
                        if (err) {
                            console.error(err);
                            return;
                        }

                        LicenceService.braintreePayment(payload , self.props.packageData , self.props.userData);
                        console.log("lets card paying")
                    });
                });
            });
        });
    }

    componentWillMount(){
        LicenceStore.once(Constants.GOT_BRAINTREE_CODE , () =>{
            console.log("hello");
           this.setupBrainTree();
        });
    }

    componentDidMount(){
        LicenceService.getCode();
    }

    render(){



        return <div>
            <div className={this.state.loading ? "animated hidden" : "animated fadeIn"}>
                <br/>
                <div>
                    <form class="payment-body">
                    <div class="row">
                        <div class="form-group col-sm-12">
                            <label class="control-label">Card Number</label>
                            <div class="form-control" id="card-number" name="number"></div>
                            <span class="helper-text"></span>
                        </div>
                    </div>
                    <div class="row">
                        <div class="form-group col-sm-6">
                            <label class="control-label">Expiration Date</label>

                            <div class="form-control" name="expiry" id="expiration-date"></div>
                        </div>
                        <div class="form-group col-sm-6">
                            <label class="control-label">CVC</label>

                            <div class="form-control" name="cvc" id="cvv"></div>
                        </div>
                    </div>


                    <button value="submit" id="submit" class="btn-block btn btn-success center-block">Pay with <span id="card-type">Card</span></button>
                </form>
                </div>
            </div>
            <div className={!this.state.loading ? "hidden" : ""}>
                <br/>
                <ProgressBar animated now={100} />
            </div>
        </div>
    }
}